import { ExpenseType } from "./expense-type";

export class Article {
    id:number = 0;
    name:string = '';
    expense_type_id:number = 0;
    expense_type:ExpenseType = new ExpenseType();
    measure_unit:string = 'pza';
    warehouse_factor:number = 1;
    warehouse_measure_unit:string = 'pza';
    uom_entry:string = null;
    uom_code:string = '';
}
